export default {
  Home: () => import('@/views/Home.vue'),
};
